module.exports = __webpack_public_path__ + "img/add_transportation_icon.bc1f87b.png";